<template>
    <div class="update-screen-form col-lg-4 mb-4">
        <transition name="loading-screen">
            <loading-screen v-if="sending" />
        </transition>
        <template v-if="errorsSending">
            <errors-zone :errors="errorsSending" />
        </template>
        <div class="card">
            <div class="card-body">
                <div class="d-flex">
                    <div class="name mb-3">
                        <span class="h5">
                            <i class="fas fa-eye-slash" v-if="screen.is_hidden"></i>
                            {{ screen.name }}
                        </span><br>
                        <div class="small text-muted">
                            <a :href="'/dashboards/screen/' + screen.uid + '?silent=true'" target="_blank">
                                {{ screen.uid }}
                            </a>
                        </div>
                        <div class="small">
                            <template v-if="screen.last_ping">
                                <span v-if="screen.is_displayed" class="text-success">
                                    {{ capitalizeFirstLetter(momentLastPing().fromNow()) }}
                                </span>
                                <span v-else class="text-warning">
                                    {{ capitalizeFirstLetter(momentLastPing().fromNow()) }}
                                </span>
                            </template>
                            <span class="text-danger" v-else>Inactif</span>
                        </div>
                        <div class="small text-primary" v-if="screen.mandatory_days.length">
                            Allumé le :
                            {{ screen.mandatory_days_label.join(', ') }}
                        </div>
                    </div>
                    <div class="ml-auto">
                        <button class="btn btn-outline-warning ml-1" @click="reloadScreen">
                            <i class="fas fa-sync-alt"></i>
                        </button>
                    </div>
                </div>

                <div class="form-group">
                    <label for="dashboard">Dashboard</label>
                    <select class="form-control" name="dashboard" id="dashboard"
                            v-model="dashboard" @change="resetOptions()">
                        <option v-for="(dashboard, name) in dashboardsComponents"
                                v-bind:value="name">{{ dashboard.name }}</option>
                    </select>
                </div>

                <div class="form-group" v-if="dashboardsComponents[dashboard] && dashboardsComponents[dashboard].options">
                    <label for="dashboard">Options</label>
                    <div class="ml-3 pl-3 border-left">
                        <div class="form-group" v-for="(option, name) in dashboardsComponents[dashboard].options">
                            <label :for="'option['+name+']'">{{ option.name || name }}</label>
                            <input class="form-control" type="text" :name="'option['+name+']'" :id="'option-'+name"
                                    v-if="option.type === 'string'" v-model="options[name]"
                                   :placeholder="option.placeholder">
                            <select class="form-control" :name="'option['+name+']'" :id="'option-'+name"
                                    v-if="option.type === 'select'" v-model="options[name]"
                                    :placeholder="option.placeholder">
                                <option v-for="(optionValue, optionName) in option.values"
                                        v-bind:value="optionValue">{{ optionName }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <button class="btn btn-outline-success ml-1" @click="updateScreen" :disabled="isDisabled">
                    Sauvegarder
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";
    import LoadingScreen from "../LoadingScreen";
    import {usePostRequest} from "../compositions/axios/postRequest";

    export default {
        name: "UpdateScreenForm",

        components: {
            'errors-zone': ErrorsZone,
            'loading-screen': LoadingScreen,
        },

        props: {
            dashboardsComponents: {
                type: Object,
                required: true,
            },
            screen: {
                type: Object,
                required: false,
            },
        },

        data() {
            return {
                options: {},
                dashboard: null,
            };
        },

        setup() {
            global.moment.relativeTimeThreshold('ss', 3);
            const {
                loading: sending,
                loaded: sent,
                errors: errorsSending,
                post: doPost,
            } = usePostRequest();

            return {
                sending,
                sent,
                errorsSending,
                doPost,
            };
        },

        computed: {
            isDisabled() {
                let isDisabled = false;
                if (!this.dashboard) {
                    isDisabled = true;
                } else {
                    if(this.dashboardsComponents[this.dashboard]) {
                        if(this.dashboardsComponents[this.dashboard].options) {
                            for (const name in this.dashboardsComponents[this.dashboard].options) {
                                if(!this.options) {
                                    isDisabled = true;
                                } else {
                                    if(this.options[name] === undefined) {
                                        isDisabled = true;
                                    }
                                }
                            }
                        }
                    }
                }
                return isDisabled;
            },
        },

        async mounted() {
            this.options = this.screen.options || {};
            this.dashboard = this.screen.dashboard || 'DashboardNoDashboard';
        },

        methods: {
            momentLastPing() {
                return this.screen.last_ping ? global.moment(this.screen.last_ping) : false;
            },
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            async reloadScreen() {
                this.$emit('submitted');
                this.sending = true;

                await this.doPost('/espace-employes/ecrans/' + this.screen.uid + '/actualiser');

                this.$emit('errors', this.errorsSending);
                if (!this.errorsSending) {
                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
                this.sending = false;
            },
            async updateScreen() {
                this.$emit('submitted');
                this.sending = true;

                await this.doPost('/espace-employes/ecrans/' + this.screen.uid, {
                    dashboard: this.dashboard,
                    options: this.options,
                });

                this.$emit('errors', this.errorsSending);
                if (!this.errorsSending) {
                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
                this.sending = false;
            },
            resetOptions() {
                this.options = {};
            }
        }
    }
</script>

<style lang="scss" scoped>
    .update-screen-form {
    }
</style>
